import { scroll, animate } from "motion";
const container = document.querySelector(".parallax");
if (container) {
	scroll(
		animate(".parallax img", {
			objectPosition: ["0 0", "0 100%"],
		}),
		{
			target: container,
			offset: ["start end", "end start"],
		}
	);
	scroll(
		animate(".parallax picture:nth-child(2) img", {
			filter: [
				"opacity(0)",
				"opacity(1)",
			],
		}),
		{
			target: container,
			offset: ["end end", "start start"],
		}
	);
}

